<div class="flex-center-column light content-block">
  <img id="logo" src="../../../assets/master-logo-white-tight.svg" />
  <div [ngClass]="(isCustomComponent$ | async) ? 'light-content-panel-custom' : 'light-content-panel'">
    <ng-content></ng-content>
  </div>
</div>
